import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import CollectionView from './views/CollectionView.vue'
// import GradientView from './views/GradientView.vue'
import GradientView2 from './views/GradientView2.vue'
import BrowseCollections from './views/BrowseCollections.vue'
import CategoryView from './views/CategoryView.vue'
import About from './views/About.vue'
import FAQ from './views/FAQ.vue'
// import PrivacyPolicy from './views/PrivacyPolicy.vue'
import Contact from './views/Contact.vue'
import LicenseAttribution from './views/LicenseAttribution.vue'
import LearnMore from './views/LearnMore.vue'
import collections from '@/util/collections.js'
import categories from '@/util/categories.js'
import Premium from '@/views/Premium.vue'
import Extended from '@/views/Extended.vue'
// import AnalyticsView from './views/AnalyticsView.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Gradient Magic - Fantastic and Unique CSS Gradients'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/faq',
      name: 'faq',
      component: FAQ
    },
    // {
    //   path: '/privacy',
    //   name: 'privacy',
    //   component: PrivacyPolicy
    // },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/licensing',
      name: 'licensing',
      component: LicenseAttribution
    },
    {
      path: '/learnmore',
      name: 'learnmore',
      component: LearnMore
    },
    {
      path: '/premium',
      name: 'premium',
      component: Premium
    },
    {
      path: '/extended',
      name: 'extended',
      component: Extended
    },
    {
      path: '/browse',
      name: 'browse',
      component: BrowseCollections
    },
    {
      path: '/collection/:cid',
      name: 'collection',
      component: CollectionView,
    },
    {
      path: '/collection/:cid/gradient/:gid',
      name: 'gradient',
      props: true,
      component: GradientView2
    },
    {
      path: '/category/:cat',
      name: 'category',
      props: true,
      component: CategoryView
    },
    // {
    //   path: '/analytics',
    //   name: 'analytics',
    //   props: true,
    //   component: AnalyticsView
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ],
  // From https://router.vuejs.org/guide/advanced/scroll-behavior.html
  // Needed to prevent a scrolling bug on FF
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }  
})


const DEFAULT_TITLE = "Gradient Magic - Fantastic and Unique CSS Gradients"

function setMetaTags(to, from){
  let docTitle = DEFAULT_TITLE

  if(to.name == "gradient"){
    docTitle = `A Cool CSS Gradient - Gradient Magic`
  }
  else if (to.name == "collection"){
    let col = collections.find((obj) => { return obj.id == to.params.cid })
    docTitle = `Gradient Collection: ${col.title} - Gradient Magic`
  }
  else if (to.name == "category"){
    let cat = categories.find((obj) => { return obj.id == to.params.cat})
    docTitle = `${cat.name} - Gradient Magic`
  }

  document.title = docTitle;
}


router.beforeEach((to, from, next) => {

  if(process.env.NODE_ENV != 'development'){

    let closingGradient = (to.name == "collection" && from.name == 'gradient');

    if(!closingGradient) gtag('config', 'UA-55527133-7', {'page_path': to.path });

    if(to.name == "collection" && !closingGradient){  
      gtag('event', 'view', {
          'event_category': 'collections',
          'event_label': to.params.cid,
          'event_value': 1
      });
    }
    else if(to.name == "gradient"){  
      gtag('event', 'view', {
          'event_category': 'gradient',
          'event_label': to.params.gid,
          'event_value': 1
      });
    }
    else if(to.name == "category"){  
      gtag('event', 'view', {
        'event_category': 'category',
        'event_label': to.params.cat,
        'event_value': 1
      });
    }
  }

  setMetaTags(to,from);

  next();
})

export default router;